import {
    Column,
    Format
} from 'devextreme-react/data-grid';

import { useGetCreditMemos } from "../api/get-credit-memos";
import { Link, useLocation } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { useAuth } from '../../../../contexts/auth';
import { CompanyTypes } from '../../../../types/enums';

export default function CreditMemoGrid() {

    const creditMemos = useGetCreditMemos();

    const location = useLocation();
    const returnUrl = encodeURIComponent(location.pathname + location.search);

    const { user } = useAuth();
    const urlFolder = user?.companyTypeId === CompanyTypes.MFR ? "manufacturer" :
        user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER ? "service-provider" : "distributor";

    return (
        <>
            <SyncDataGrid
                stateStorageKey={urlFolder + '-credit-memo-grid'}
                className={'dx-card wide-card'}
                dataSource={creditMemos.data}
                keyExpr={'creditMemoID'}
                height="68vh"
            >
                <Column
                    dataField={'creditMemoNumber'}
                    caption={'Credit Memo Number'}
                    dataType="string"
                    cellRender={(row: any) => {
                        return <Link to={`/${urlFolder}/credit-memo/${row.data.purchaseOrderID}/${row.data.creditMemoID}?returnUrl=${returnUrl}`}>
                            {row.data.creditMemoNumber}
                        </Link>;
                    }}
                />
                <Column
                    dataField={'invoiceDate'}
                    caption={'Invoice Date'}
                    dataType="date"
                />
                <Column
                    dataField={'cfiName'}
                    caption={'CFI Name'}
                    dataType="string"
                />
                <Column
                    dataField={'balance'}
                    caption={'Balance'}
                    dataType="number"
                    editorOptions={{ format: '$#,##0.##', showClearButton: true }}
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
            </SyncDataGrid>

            <LoadPagePanel visible={creditMemos.isLoading} />
        </>
    )
} 
